import React from 'react'
import { useNavigate } from 'react-router-dom'

const WelcomePage = () => {
    const navigate = useNavigate()
  return (
    <main className="auth">
      <div className="auth-layout">
        <div className="auth-view">
          <div className="welcome-page-auth-view__container" style={{background: 'linear-gradient(to bottom, #26262f 50%, #d1b794 100%)'}}>
            <div className="welcome-page-view">
              <div className="welcome-page-heading">Welcome to STG90!</div>
              <div className='welcome-page-paras'>
                <p className='setting-para'>Setting up your 90 Day Target Protocol takes about 90 min.</p>
                <p className='suggest-para'>We suggest you do it on a desktop or a laptop.</p>
              </div>
              <form className="welcome-page-driver-form">
                <div
                  style={{
                    display: "flex",
                    // gap: "1rem",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <button type="button" className="welcome-page-btn" onClick={() => navigate('/onboarding-driver')}>
                    <span className="driver-button__label">I'm ready to go NOW</span>
                  </button>

                  <button type="button" className="welcome-page-next-btn" onClick={() => navigate('/courses')}>
                    <span className="driver-button__label">I'll do this later</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default WelcomePage